<div class="humidityStatistics">
  <app-asset-hierarchy (assetClicked)="onAssetSelected($event)"> </app-asset-hierarchy>
  @if (this.selectedAsset()) {
    <div class="container">
      <div class="widget humidityChart">
        <app-humidity-chart
          [chartData]="humidityStatisticsFacade.lineChartHumidity()"
          chartId="humidityChartStats"
          (changeTimeframeEvent)="onChangedTimeframe($event)"
          [realtimePoint$]="humidityStatisticsFacade.realtimePoint$"
        ></app-humidity-chart>
      </div>
    </div>
  }
</div>
